/*
 * This file is a generated Typescript file for GRPC Gateway, DO NOT MODIFY
 */

import * as fm from "../../../fm"

import * as commonV1 from "./deviceapis_device_common_v1.pb"

/**
 * Сервис RFID ключей устройства
 */

/**
 * Сервис RFID ключей устройства
 */
export class RfidServiceClient {
  /**
   * Конструктор сервиса
   * @param host Адрес хоста
   * @param token Токен доступа
   */
  constructor(
    public host = "",
    public token = ""
  ) { }

  /**
   * Метод удаления единичной сущности Rfid по ключу
   */
  DeleteRfid = (req: DeleteRfidRequestDto, init?: RequestInit): Promise<DeleteRfidResponseDto> => {
    return fm.request<DeleteRfidRequestDto, DeleteRfidResponseDto>(`${this.host}/device/api/v1/rfid/${encodeURIComponent(req.id)}`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод удаления списка сущностей Rfid по фильтру
   */
  DeleteRfidList = (req?: DeleteRfidListRequestDto, init?: RequestInit): Promise<DeleteRfidListResponseDto> => {
    return fm.request<DeleteRfidListRequestDto, DeleteRfidListResponseDto>(`${this.host}/device/api/v1/rfid/list`, { ...init, method: "DELETE", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения единичной сущности Rfid по ключу
   */
  GetRfid = (req: GetRfidRequestDto, init?: RequestInit): Promise<GetRfidResponseDto> => {
    return fm.request<GetRfidRequestDto, GetRfidResponseDto>(`${this.host}/device/api/v1/rfid/${encodeURIComponent(req.id)}${fm.buildQuery(req, ["id"])}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения количества сущностей Rfid по фильтру
   */
  GetRfidCount = (req?: GetRfidCountRequestDto, init?: RequestInit): Promise<GetRfidCountResponseDto> => {
    return fm.request<GetRfidCountRequestDto, GetRfidCountResponseDto>(`${this.host}/device/api/v1/rfid/count${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод получения списка сущностей Rfid по фильтру
   */
  GetRfidList = (req?: GetRfidListRequestDto, init?: RequestInit): Promise<GetRfidListResponseDto> => {
    return fm.request<GetRfidListRequestDto, GetRfidListResponseDto>(`${this.host}/device/api/v1/rfid/list${fm.buildQuery(req)}`, { ...init, method: "GET", ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод редактирования сущности Rfid
   */
  SaveRfid = (req: SaveRfidRequestDto, init?: RequestInit): Promise<SaveRfidResponseDto> => {
    return fm.request<SaveRfidRequestDto, SaveRfidResponseDto>(`${this.host}/device/api/v1/rfid`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

  /**
   * Метод редактирования списка сущностей Rfid
   */
  SaveRfidList = (req?: SaveRfidListRequestDto, init?: RequestInit): Promise<SaveRfidListResponseDto> => {
    return fm.request<SaveRfidListRequestDto, SaveRfidListResponseDto>(`${this.host}/device/api/v1/rfid/list`, { ...init, method: "POST", body: JSON.stringify(req, fm.replacer), ...{ headers: { ...init?.headers, ...{ 'Authorization': `Bearer ${this.token}` } } } })
  }

}

/**
 * Запрос удаления списка сущностей Rfid по фильтру
 */
export type DeleteRfidListRequestDto = {
}
/**
 * Ответ на запрос удаления списка сущностей Rfid по фильтру
 */
export type DeleteRfidListResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего количество удаленных
   */
  readonly data: number
}>
/**
 * Запрос удаления единичной сущности Rfid по ключу
 */
export type DeleteRfidRequestDto = {
  /**
   * Идентификатор UID [hex 14]
   */
  id: string
}
/**
 * Ответ на запрос удаления единичной сущности Rfid по ключу
 */
export type DeleteRfidResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ошибка
   */
  readonly error: DeleteRfidResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type DeleteRfidResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type DeleteRfidResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
}>
/**
 * Запрос получения количества сущностей Rfid по фильтру
 */
export type GetRfidCountRequestDto = {
}
/**
 * Ответ на запрос получения количества сущностей Rfid по фильтру
 */
export type GetRfidCountResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Всего количество
   */
  readonly data: number
}>
/**
 * Запрос получения списка сущностей Rfid по фильтру
 */
export type GetRfidListRequestDto = {
}
/**
 * pagination
 */
& fm.OptionalOneOf<{
  /**
   * Постраничный вывод
   */
  readonly paging: RfidPagingRequestDto
}>
/**
 * Ответ на запрос получения списка сущностей Rfid по фильтру
 */
export type GetRfidListResponseDto = {
  /**
   * Список Rfid
   */
  data: RfidResponseDto[]
}
/**
 * Запрос получения единичной сущности Rfid по ключу
 */
export type GetRfidRequestDto = {
  /**
   * Идентификатор UID [hex 14]
   */
  id: string
}
/**
 * Ответ на запрос получения единичной сущности Rfid по ключу
 */
export type GetRfidResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ключ
   */
  readonly data: RfidResponseDto
}>
/**
 * Ключ
 */
export type RfidRequestDto = {
  /**
   * Идентификатор UID [hex 14]
   */
  id: string
  /**
   * Описание
   */
  description?: string | null
  /**
   * Секрет [hex 14]
   */
  secret?: string | null
  /**
   * Идентификаторы реле.
   * Диапазон: 1..64
   */
  relayIndexes?: number[]
}
/**
 * Ключ
 */
export type RfidResponseDto = {
  /**
   * Идентификатор UID [hex 14]
   */
  id: string
  /**
   * Описание
   */
  description: string | null
  /**
   * Секрет [hex 14]
   */
  secret: string | null
  /**
   * Идентификаторы реле.
   * Диапазон: 1..64
   */
  relayIndexes: number[]
}
/**
 * Ошибка запроса создания ключа
 */
export type RfidSavingErrorRequestDto = {
}
/**
 * reason
 */
& fm.OptionalOneOf<{
  /**
   * Реле не найдено
   */
  readonly relayNotFound: RfidSavingErrorRelayNotFoundRequestDto
}>
/**
 * Ошибка запроса создания ключа
 */
export type RfidSavingErrorResponseDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Реле не найдено
   */
  readonly relayNotFound: RfidSavingErrorRelayNotFoundResponseDto
}>
/**
 * Реле не найдено
 */
export type RfidSavingErrorRelayNotFoundRequestDto = {
}
/**
 * Реле не найдено
 */
export type RfidSavingErrorRelayNotFoundResponseDto = {
}
/**
 * Постраничный вывод
 */
export type RfidPagingRequestDto = {
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit?: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset?: number
}
/**
 * Постраничный вывод
 */
export type RfidPagingResponseDto = {
  /**
   * Количество записей на страницу.
   * Если значение 0 (не передано), то будет взято значение по умолчанию.
   * # Диапазон: 0..100.
   * # По умолчанию: 20
   */
  limit: number
  /**
   * Сдвиг.
   * # Диапазон: 0..2147483647
   */
  offset: number
}
/**
 * Запрос на редактирование списка сущностей Rfid
 */
export type SaveRfidListRequestDto = {
  /**
   * Список Rfid
   */
  data?: RfidRequestDto[]
}
/**
 * Ответ на запрос на редактирование списка сущностей Rfid
 */
export type SaveRfidListResponseDto = {
  /**
   * Список Rfid
   */
  data: RfidResponseDto[]
  /**
   * Список ошибок
   */
  errors: SaveRfidListResponseErrorDto[]
}
/**
 * Ошибка запроса
 */
export type SaveRfidListResponseErrorRequestDto = {
  /**
   * Идентификатор UID [hex 14]
   */
  id: string
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: RfidSavingErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type SaveRfidListResponseErrorDto = {
  /**
   * Идентификатор UID [hex 14]
   */
  id: string
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: RfidSavingErrorResponseDto
}>
/**
 * Запрос на создания/редактирование сущности Rfid
 */
export type SaveRfidRequestDto = {
  /**
   * Ключ
   */
  data: RfidRequestDto
}
/**
 * Ответ на запрос на создания/редактирование сущности Rfid
 */
export type SaveRfidResponseDto = {
}
/**
 * type
 */
& fm.OneOf<{
  /**
   * Ключ
   */
  readonly data: RfidResponseDto
  /**
   * Ошибка
   */
  readonly error: SaveRfidResponseErrorDto
}>
/**
 * Ошибка запроса
 */
export type SaveRfidResponseErrorRequestDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorRequestDto
  /**
   * Ошибка сохранения
   */
  readonly saving: RfidSavingErrorRequestDto
}>
/**
 * Ошибка запроса
 */
export type SaveRfidResponseErrorDto = {
}
/**
 * reason
 */
& fm.OneOf<{
  /**
   * Ошибка валидации
   */
  readonly validation: commonV1.ValidationErrorResponseDto
  /**
   * Ошибка сохранения
   */
  readonly saving: RfidSavingErrorResponseDto
}>
/**
 * Дескриптор
 */
export const descriptor = {
  /**
   * Запрос удаления списка сущностей Rfid по фильтру
   */
  "DeleteRfidListRequest": {
    "kind": "class",
    "text": "Запрос удаления списка сущностей Rfid по фильтру",
  },
  /**
   * Ответ на запрос удаления списка сущностей Rfid по фильтру
   */
  "DeleteRfidListResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления списка сущностей Rfid по фильтру",
    "fields": {
      /**
       * Всего количество удаленных
       */
      "data": {
        "type": "int32",
        "text": "Всего количество удаленных",
      },
    },
  },
  /**
   * Запрос удаления единичной сущности Rfid по ключу
   */
  "DeleteRfidRequest": {
    "kind": "class",
    "text": "Запрос удаления единичной сущности Rfid по ключу",
    "fields": {
      /**
       * Идентификатор UID [hex 14]
       */
      "id": {
        "type": "string",
        "text": "Идентификатор UID [hex 14]",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос удаления единичной сущности Rfid по ключу
   */
  "DeleteRfidResponse": {
    "kind": "class",
    "text": "Ответ на запрос удаления единичной сущности Rfid по ключу",
    "fields": {
      /**
       * Ошибка
       */
      "error": {
        "type": "DeleteRfidResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "DeleteRfidResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
    },
  },
  /**
   * Запрос получения количества сущностей Rfid по фильтру
   */
  "GetRfidCountRequest": {
    "kind": "class",
    "text": "Запрос получения количества сущностей Rfid по фильтру",
  },
  /**
   * Ответ на запрос получения количества сущностей Rfid по фильтру
   */
  "GetRfidCountResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения количества сущностей Rfid по фильтру",
    "fields": {
      /**
       * Всего количество
       */
      "data": {
        "type": "int32",
        "text": "Всего количество",
      },
    },
  },
  /**
   * Запрос получения списка сущностей Rfid по фильтру
   */
  "GetRfidListRequest": {
    "kind": "class",
    "text": "Запрос получения списка сущностей Rfid по фильтру",
    "fields": {
      /**
       * Постраничный вывод
       */
      "paging": {
        "type": "RfidPaging",
        "text": "Постраничный вывод",
      },
    },
  },
  /**
   * Ответ на запрос получения списка сущностей Rfid по фильтру
   */
  "GetRfidListResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения списка сущностей Rfid по фильтру",
    "fields": {
      /**
       * Список Rfid
       */
      "data": {
        "type": "Rfid",
        "text": "Список Rfid",
      },
    },
  },
  /**
   * Запрос получения единичной сущности Rfid по ключу
   */
  "GetRfidRequest": {
    "kind": "class",
    "text": "Запрос получения единичной сущности Rfid по ключу",
    "fields": {
      /**
       * Идентификатор UID [hex 14]
       */
      "id": {
        "type": "string",
        "text": "Идентификатор UID [hex 14]",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос получения единичной сущности Rfid по ключу
   */
  "GetRfidResponse": {
    "kind": "class",
    "text": "Ответ на запрос получения единичной сущности Rfid по ключу",
    "fields": {
      /**
       * Ключ
       */
      "data": {
        "type": "Rfid",
        "text": "Ключ",
      },
    },
  },
  /**
   * Ключ
   */
  "Rfid": {
    "kind": "class",
    "text": "Ключ",
    "fields": {
      /**
       * Идентификатор UID [hex 14]
       */
      "id": {
        "type": "string",
        "text": "Идентификатор UID [hex 14]",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Описание
       */
      "description": {
        "type": "google.protobuf.StringValue",
        "text": "Описание",
      },
      /**
       * Секрет [hex 14]
       */
      "secret": {
        "type": "google.protobuf.StringValue",
        "text": "Секрет [hex 14]",
      },
      /**
       * Идентификаторы реле.
       * Диапазон: 1..64
       */
      "relayIndexes": {
        "type": "int32",
        "text": "Идентификаторы реле.\nДиапазон: 1..64",
      },
    },
  },
  /**
   * Ошибка запроса создания ключа
   */
  "Rfid.SavingError": {
    "kind": "class",
    "text": "Ошибка запроса создания ключа",
    "fields": {
      /**
       * Реле не найдено
       */
      "relayNotFound": {
        "type": "Rfid.SavingError.RelayNotFound",
        "text": "Реле не найдено",
      },
    },
  },
  /**
   * Реле не найдено
   */
  "Rfid.SavingError.RelayNotFound": {
    "kind": "class",
    "text": "Реле не найдено",
  },
  /**
   * Постраничный вывод
   */
  "RfidPaging": {
    "kind": "class",
    "text": "Постраничный вывод",
    "fields": {
      /**
       * Количество записей на страницу.
       * Если значение 0 (не передано), то будет взято значение по умолчанию.
       * # Диапазон: 0..100.
       * # По умолчанию: 20
       */
      "limit": {
        "type": "int32",
        "text": "Количество записей на страницу.\nЕсли значение 0 (не передано), то будет взято значение по умолчанию.\n# Диапазон: 0..100.\n# По умолчанию: 20",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 100,
            "message": "Значение не входит в допустимый диапазон. Максимум: 100"
          },
        }
      },
      /**
       * Сдвиг.
       * # Диапазон: 0..2147483647
       */
      "offset": {
        "type": "int32",
        "text": "Сдвиг.\n# Диапазон: 0..2147483647",
        "rules": {
          "min": {
            "value": 0,
            "message": "Значение не входит в допустимый диапазон. Минимум: 0"
          },
          "max": {
            "value": 2147483647,
            "message": "Значение не входит в допустимый диапазон. Максимум: 2147483647"
          },
        }
      },
    },
  },
  /**
   * Запрос на редактирование списка сущностей Rfid
   */
  "SaveRfidListRequest": {
    "kind": "class",
    "text": "Запрос на редактирование списка сущностей Rfid",
    "fields": {
      /**
       * Список Rfid
       */
      "data": {
        "type": "Rfid",
        "text": "Список Rfid",
      },
    },
  },
  /**
   * Ответ на запрос на редактирование списка сущностей Rfid
   */
  "SaveRfidListResponse": {
    "kind": "class",
    "text": "Ответ на запрос на редактирование списка сущностей Rfid",
    "fields": {
      /**
       * Список Rfid
       */
      "data": {
        "type": "Rfid",
        "text": "Список Rfid",
      },
      /**
       * Список ошибок
       */
      "errors": {
        "type": "SaveRfidListResponse.Error",
        "text": "Список ошибок",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "SaveRfidListResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Идентификатор UID [hex 14]
       */
      "id": {
        "type": "string",
        "text": "Идентификатор UID [hex 14]",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Rfid.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
  /**
   * Запрос на создания/редактирование сущности Rfid
   */
  "SaveRfidRequest": {
    "kind": "class",
    "text": "Запрос на создания/редактирование сущности Rfid",
    "fields": {
      /**
       * Ключ
       */
      "data": {
        "type": "Rfid",
        "text": "Ключ",
        "rules": {
          "required": "Значение обязательно для заполнения",
        }
      },
    },
  },
  /**
   * Ответ на запрос на создания/редактирование сущности Rfid
   */
  "SaveRfidResponse": {
    "kind": "class",
    "text": "Ответ на запрос на создания/редактирование сущности Rfid",
    "fields": {
      /**
       * Ключ
       */
      "data": {
        "type": "Rfid",
        "text": "Ключ",
      },
      /**
       * Ошибка
       */
      "error": {
        "type": "SaveRfidResponse.Error",
        "text": "Ошибка",
      },
    },
  },
  /**
   * Ошибка запроса
   */
  "SaveRfidResponse.Error": {
    "kind": "class",
    "text": "Ошибка запроса",
    "fields": {
      /**
       * Ошибка валидации
       */
      "validation": {
        "type": "ValidationError",
        "text": "Ошибка валидации",
      },
      /**
       * Ошибка сохранения
       */
      "saving": {
        "type": "Rfid.SavingError",
        "text": "Ошибка сохранения",
      },
    },
  },
}